/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Sign_In_DescriptionInputs */

const en_agent_authorization_sign_in_description = /** @type {(inputs: Agent_Authorization_Sign_In_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use your Seek AI account to approve or reject this request. You will return to this page after signing in.`)
};

const zh_agent_authorization_sign_in_description = /** @type {(inputs: Agent_Authorization_Sign_In_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 Seek AI 账号批准或拒绝。登录完成后会回到当前页面。`)
};

/**
* | output |
* | --- |
* | "Use your Seek AI account to approve or reject this request. You will return to this page after signing in." |
*
* @param {Agent_Authorization_Sign_In_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_sign_in_description = /** @type {((inputs?: Agent_Authorization_Sign_In_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Sign_In_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_sign_in_description(inputs)
	return zh_agent_authorization_sign_in_description(inputs)
});
export { agent_authorization_sign_in_description as "agent.authorization.sign_in_description" }